import Vue from 'vue'
import VueRouter from 'vue-router'
import home from '../views/home'
Vue.use(VueRouter)

const routes = [
    // 登录
    {
        path: '/',
        name: 'login',
        component: () =>
            import('../views/login')
    },
    // 注册
    {
        path: '/register',
        name: 'register',
        component: () =>
            import('../views/login/register.vue')
    },
    // 学校服务
    {
        path: '/schoolserve',
        name: 'schoolserve',
        component: () =>
            import('../views/login/schoolserve.vue')
    },
    // 帮助中心  
    {
        path: '/helpcenter',
        name: 'helpcenter',
        component: () =>
            import('../views/login/helpcenter.vue')
    },
    // 忘记密码
    {
        path: '/forgetPassword',
        name: 'forgetPassword',
        component: () =>
            import('../views/login/forgetPassword.vue')
    },
    // 一、首页
    {
        path: '/home',
        name: 'home',
        component: home
    },

    // 二、资源
    {
        path: '/resourceCenter',
        name: 'resourceCenter',
        redirect: '/resourceCenter/resource',
        component: () =>
            import('../views/resourceCenter'),
        children: [{
                path: '/resourceCenter/resource',
                name: 'resource',
                component: () =>
                    import('../views/resourceCenter/resource')
            },
            // 资源详情
            {
                path: '/resourceCenter/details',
                name: 'details',
                component: () =>
                    import('../views/resourceCenter/details')
            },
        ]
    },

    // 三、备课
    {
        path: '/prepareLessons',
        name: 'prepareLessons',
        redirect: '/prepareLessons/myLessons',
        component: () =>
            import('../views/prepareLessons'),
        children: [{
                path: '/prepareLessons/myLessons',
                name: 'myLessons',
                component: () =>
                    import('../views/prepareLessons/myLessons.vue')
            },
            {
                path: '/prepareLessons/newLesson',
                name: 'newLesson',
                component: () =>
                    import('../views/prepareLessons/newLesson.vue')
            },
            {
                path: '/prepareLessons/collaborativeLesson',
                name: 'collaborativeLesson',
                component: () =>
                    import('../views/prepareLessons/collaborativeLesson.vue')
            },
        ]
    },
    //四、 作业
    {
        path: '/homework',
        name: 'homework',
        redirect: '/homework/inde',
        component: () =>
            import('../views/homework'),
        children: [
            //首页
            {
                path: '/homework/inde',
                name: 'inde',
                component: () =>
                    import('../views/homework/inde.vue')
            },
            //发布任务
            {
                path: '/homework/issuework',
                name: 'issuework',
                component: () =>
                    import('../views/homework/issuework.vue')
            },
            //题库选题
            {
                path: '/homework/wordlist',
                name: 'wordlist',
                component: () =>
                    import('../views/homework/wordlist.vue')
            },
            //学生作业
            {
                path: '/homework/workcheck',
                name: 'workcheck',
                component: () =>
                    import('../views/homework/workcheck.vue')
            },
            //批改
            {
                path: '/homework/remarks',
                name: 'remarks',
                component: () =>
                    import('../views/homework/remarks.vue')
            },
            //作业详情
            {
                path: '/homework/workreport',
                name: 'workreport',
                component: () =>
                    import('../views/homework/workreport.vue')
            },
            //任务详情
            {
                path: '/homework/taskdetail',
                name: 'taskdetail',
                component: () =>
                    import('../views/homework/taskdetail.vue')
            },
            //自定义详情
            {
                path: '/homework/customwork',
                name: 'customwork',
                component: () =>
                    import('../views/homework/customwork.vue')
            },


        ],

    },
    //任务
    {
        path: '/taskwork',
        name: 'taskwork',
        redirect: '/taskwork/taskwork',
        component: () => import('../views/taskwork'),
        children: [
            //首页
            {
                path: '/taskwork/taskwork',
                name: 'index',
                component: () =>
                    import('../views/taskwork/taskwork.vue')
            },
            //详情
            {
                path: '/taskwork/taskcheck',
                name: 'taskcheck',
                component: () =>
                    import('../views/taskwork/taskcheck.vue')
            },
            //详情
            {
                path: '/taskwork/sendwork',
                name: 'sendwork',
                component: () =>
                    import('../views/taskwork/sendwork.vue')
            },


        ],

    },

    // 五、组卷

    {
        path: '/testPaper',
        name: 'testPaper',
        redirect: '/testPaper/ChapterTopics',
        component: () =>
            import('../views/testPaper'),
        children: [{
                path: '/testPaper/KnowledgTopics', //知识点
                name: 'KnowledgTopics',
                component: () =>
                    import('../views/testPaper/KnowledgTopics')
            },
            {
                path: '/testPaper/ChapterTopics', //章节
                name: 'ChapterTopics',
                component: () =>
                    import('../views/testPaper/ChapterTopics')
            },
            {
                path: '/testPaper/SmartTopics', //智能
                name: 'SmartTopics',
                component: () =>
                    import('../views/testPaper/SmartTopics')
            },
            {
                path: '/testPaper/FavoriteTopics', //收藏夹
                name: 'FavoriteTopics',
                component: () =>
                    import('../views/testPaper/FavoriteTopics')
            },
            {
                path: '/testPaper/PersonalTopics', //我的（个人中心）
                name: 'PersonalTopics',
                component: () =>
                    import('../views/testPaper/PersonalTopics')
            },
            {
                path: '/testPaper/examPaper', //试卷页面
                name: 'examPaper',
                component: () =>
                    import('../views/testPaper/examPaper.vue')
            },
        ]
    },




    // 六、空间
    {
        path: '/space',
        name: 'space',
        redirect: '/space/dynamic',
        component: () =>
            import('../views/space'),
        children: [
            // 最新动态
            {
                path: '/space/dynamic',
                name: 'dynamic',
                component: () =>
                    import('../views/space/dynamic/dynamic.vue'),
            },
            // 班级圈
            {
                path: '/space/glass',
                name: 'glass',
                component: () =>
                    import('../views/space/glass.vue')
            },
            // 粉丝
            {
                path: '/space/fensi',
                name: 'fensi',
                component: () =>
                    import('../views/space/dynamic/fensi.vue')
            },
            // 关注
            {
                path: '/space/guanzhu',
                name: 'guanzhu',
                component: () =>
                    import('../views/space/dynamic/guanzhu.vue')
            },
            // 更多
            {
                path: '/space/UserIfon',
                name: 'UserIfon',
                component: () =>
                    import('../views/space/dynamic/gengduo.vue')
            },

            // 学校圈
            {
                path: '/space/school',
                name: 'school',
                component: () =>
                    import('../views/space/school.vue')
            },
            // 说说
            {
                path: '/space/saying',
                name: 'saying',
                component: () =>
                    import('../views/space/saying.vue')
            },
            // 日志
            {
                path: '/space/Journal',
                name: 'Journal',
                component: () =>
                    import('../views/space/daily/Journal.vue')
            },
            //写日志
            {
                path: '/space/editlog',
                name: 'editlog',
                component: () =>
                    import('../views/space/daily/editlog.vue')
            },
            //日志详情
            {
                path: '/space/particular',
                name: 'particular',
                component: () =>
                    import('../views/space/daily/particulars.vue')
            },
            // 相册
            {
                path: '/space/ablum',
                name: 'ablum',
                component: () =>
                    import('../views/space/ablum.vue')
            },

            // 留言板
            {
                path: '/space/Message',
                name: 'Message',
                component: () =>
                    import('../views/space/Message.vue')
            },
            // 收藏
            {
                path: '/space/Collection',
                name: 'Collection',
                component: () =>
                    import('../views/space/Collection.vue')
            },
        ]
    },


    {
        path: '/space/Every', //人人通空间
        name: 'Every',
        component: () =>
            import('../views/space/dynamic/every.vue')

    },

    {
        path: '/space/infomalloc', //申请空间
        name: 'infomalloc',
        component: () =>
            import('../views/space/dynamic/infomalloc.vue')

    },

    // 七、个人中心
    {
        path: '/person',
        name: 'person',
        redirect: '/person/info',
        component: () =>
            import('../views/person'),
        children: [{
                path: '/person/info',
                name: 'info',
                component: () =>
                    import('../views/person/info.vue')
            },
            // 消息
            {
                path: '/person/news',
                name: 'news',
                redirect: '/person/systemMessage',
                component: () =>
                    import('../views/person/news'),
                children: [{
                        path: '/person/systemMessage',
                        name: 'systemMessage',
                        component: () =>
                            import('../views/person/news/systemMessage.vue')
                    },
                    {
                        path: '/person/jobMessage',
                        name: 'jobMessage',
                        component: () =>
                            import('../views/person/news/jobMessage.vue')
                    },
                    {
                        path: '/person/homeworkAQ',
                        name: 'homeworkAQ',
                        component: () =>
                            import('../views/person/news/homeworkAQ.vue')
                    },
                    {
                        path: '/person/Me',
                        name: 'Me',
                        component: () =>
                            import('../views/person/news/Me.vue')
                    },
                    {
                        path: '/person/comment',
                        name: 'comment',
                        component: () =>
                            import('../views/person/news/comment.vue')
                    },
                    {
                        path: '/person/praise',
                        name: 'praise',
                        component: () =>
                            import('../views/person/news/praise.vue')
                    },
                    {
                        path: '/person/newConcerns',
                        name: 'newConcerns',
                        component: () =>
                            import('../views/person/news/newConcerns.vue')
                    },

                ],
            },
        ]
    },

]



const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}


const router = new VueRouter({
    routes
})

router.beforeEach((to, from, next) => {
    if (localStorage.getItem('loginInfo')) {
        if (to.path == '/') {
            next({
                path: "/home"
            }); //放行到/home 
        } else {
            next(); // 继续执行接下来的操作
        }
        //是否有学校
        // if (localStorage.getItem('loginInfo').school_id) {
        //     next({
        //         path: "/home"
        //     }); //放行到/home 
        // } else {
        //     next({
        //         path: "/schoolserve"
        //     });
        // }
    } else {
        if (to.path == '/' || to.path == '/register' || to.path == '/forgetPassword') {
            next();
        } else {
            next({
                path: "/"
            });
        }
    }
})

export default router